import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitoindorecab() {



const cardData = {
  keyword: " Mumbai to Indore Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Indore cab services for travelers seeking a safe, smooth, and convenient journey between Maharashtra and Madhya Pradesh. Whether you are planning a business trip, family visit, weekend getaway, or group travel, our cab service ensures a hassle-free ride with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Indore cab services.",

topPlaces: [
  {
    title: "Rajwada Palace",
    description:
      "Rajwada Palace is a historic royal palace in Indore, showcasing Maratha architecture with intricate carvings and grand courtyards. Visitors can explore the palace halls, take photographs, and learn about the royal history of the Holkar dynasty. Traveling by cab ensures a comfortable journey from Mumbai, allowing ample time to enjoy this heritage site."
  },
  {
    title: "Lal Bagh Palace",
    description:
      "Lal Bagh Palace is an opulent palace featuring European-style architecture, beautiful gardens, and a museum displaying royal artifacts. Visitors can explore the grand interiors, enjoy photography, and relax in the surrounding gardens. A cab ride provides hassle-free access, enabling tourists to include this landmark in their sightseeing itinerary."
  },
  {
    title: "Kanch Mandir",
    description:
      "Kanch Mandir is a stunning Jain temple made entirely of glass, known for its intricate glasswork and spiritual significance. Visitors can admire the architecture, perform rituals, and capture photographs. Traveling by cab ensures convenient transport from Mumbai, allowing enough time to explore this unique temple."
  },
  {
    title: "Indore Sarafa Bazaar",
    description:
      "Sarafa Bazaar is a bustling night market famous for street food, local snacks, and shopping. Visitors can taste Indore’s culinary specialties, shop for jewelry and handicrafts, and enjoy the vibrant atmosphere. A cab service provides comfortable access, making it easy to combine cultural and culinary exploration with sightseeing."
  },
  {
    title: "Chhatri Bagh",
    description:
      "Chhatri Bagh is a garden featuring cenotaphs of the Holkar rulers, with beautiful architecture and peaceful surroundings. Visitors can explore the memorials, enjoy photography, and relax in the serene environment. Traveling by cab ensures easy access and allows tourists to include it alongside other historical attractions."
  },
  {
    title: "Patalpani Waterfall",
    description:
      "Patalpani Waterfall is a scenic natural attraction near Indore, especially captivating during the monsoon season. Visitors can enjoy trekking, photography, and picnics amidst lush greenery. A cab ride ensures comfortable travel from Mumbai, allowing ample time to explore the waterfall and surrounding areas."
  },
  {
    title: "Ralamandal Wildlife Sanctuary",
    description:
      "Ralamandal Wildlife Sanctuary offers nature trails, birdwatching, and a peaceful forest environment. Visitors can enjoy hiking, photography, and observing local flora and fauna. Traveling by cab ensures safe and hassle-free access, making it convenient to include the sanctuary in the Indore sightseeing itinerary."
  },
  {
    title: "Khajrana Ganesh Temple",
    description:
      "Khajrana Ganesh Temple is a famous religious site in Indore dedicated to Lord Ganesh. Visitors can perform rituals, experience the spiritual ambiance, and capture photographs. A cab ride provides easy access from Mumbai, allowing enough time for spiritual and cultural experiences."
  },
  {
    title: "Treasure Island Mall",
    description:
      "Treasure Island Mall is a modern shopping and entertainment destination in Indore, featuring retail stores, food courts, and cinemas. Visitors can shop, dine, and enjoy leisure activities. Traveling by cab ensures convenient transport, enabling tourists to combine shopping with sightseeing efficiently."
  },
  {
    title: "Bada Ganpati",
    description:
      "Bada Ganpati is one of the largest Ganesh idols in the world, located in Indore. Visitors can admire the monumental statue, perform rituals, and take photographs. A cab service provides comfortable access from Mumbai, making it easy to include this spiritual and cultural landmark in the itinerary."
  }
],




services: [
{
name: "Mumbai to Indore Cab",
description: "Mumbai to Indore cab service provides comfortable and reliable interstate travel between Maharashtra and Madhya Pradesh. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth long-distance highway journeys. Professional drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. Ideal for business travel, family visits, and corporate trips. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options allow convenient travel planning. Transparent pricing ensures a smooth and stress-free cab booking experience."
},
{
name: "Mumbai to Indore Taxi",
description: "Mumbai to Indore taxi service offers dependable road transportation for travelers planning interstate journeys. Comfortable AC vehicles ensure pleasant long-distance travel across major national highways. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, family visits, and tourism travel. Clean interiors and spacious seating provide a comfortable travel experience. Flexible departure schedules allow passengers to plan trips easily. Reliable taxi services ensure smooth and safe intercity travel."
},
{
name: "Mumbai to Indore Cab Service",
description: "Mumbai to Indore cab service offers reliable transportation for passengers traveling between two important cities. Our well-maintained AC vehicles ensure smooth highway travel and comfortable seating. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from residential areas, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, tourism trips, and family visits. Spacious interiors ensure comfortable seating for long-distance journeys. Flexible booking options allow passengers to schedule trips easily. Transparent pricing ensures dependable cab service."
},
{
name: "Mumbai to Indore Taxi Service",
description: "Mumbai to Indore taxi service offers convenient and comfortable road travel for passengers planning interstate trips. Our fleet includes AC sedans and SUVs suitable for long-distance journeys. Skilled drivers ensure safe highway driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travelers, families, and tourists. Spacious seating ensures passenger comfort throughout the journey. Flexible travel schedules allow convenient trip planning. Affordable fares ensure smooth taxi travel."
},
{
name: "Cab from Mumbai to Indore",
description: "Cab from Mumbai to Indore offers private and comfortable transportation for travelers seeking long-distance travel solutions. AC vehicles ensure smooth and relaxed highway journeys throughout the trip. Professional drivers ensure safe driving and reliable travel services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travelers, families, and tourists. Spacious interiors provide comfortable seating for extended journeys. Flexible departure timing allows convenient trip planning. Reliable cab services ensure stress-free travel."
},
{
name: "Taxi from Mumbai to Indore",
description: "Taxi from Mumbai to Indore provides dependable road travel for passengers visiting the commercial city of Indore. Comfortable AC vehicles ensure pleasant travel conditions throughout the journey. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travelers, family trips, and tourism travel. Clean interiors and spacious seating ensure passenger comfort. Flexible scheduling options allow easy travel planning. Professional taxi services ensure reliable intercity transportation."
},
{
name: "Mumbai to Indore Cab Booking",
description: "Mumbai to Indore cab booking allows passengers to reserve vehicles easily for interstate travel. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel, relocation trips, and family visits. Flexible one-way and round-trip booking options are available. Reliable booking services ensure hassle-free travel planning."
},
{
name: "Mumbai to Indore Taxi Booking Online",
description: "Mumbai to Indore taxi booking online provides quick and convenient reservations for passengers planning long-distance travel. Instant booking confirmation helps travelers schedule trips easily. Comfortable AC vehicles ensure relaxed highway travel conditions. Experienced drivers ensure safe and professional driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travelers and families. Flexible travel timing allows convenient trip scheduling. Reliable booking systems ensure smooth taxi reservations."
},
{
name: "Mumbai to Indore Cab Price",
description: "Mumbai to Indore cab price offers transparent and affordable travel options for passengers planning interstate journeys. Clear pricing details allow travelers to understand total trip costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe highway travel and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai to Indore Taxi Fare",
description: "Mumbai to Indore taxi fare is calculated using transparent per-kilometer pricing to provide clear travel costs. Passengers can choose vehicles based on comfort and budget preferences. Our AC vehicles ensure smooth interstate highway travel between the two cities. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business trips and family travel. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Indore One Way Cab",
description: "Mumbai to Indore one way cab service is ideal for travelers who require drop service without paying return charges. This option helps reduce overall travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance highway journeys. Professional drivers ensure safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, relocation trips, and personal journeys. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable travel."
}
],

tableData: [
["Mumbai to Indore Cab","Mumbai to Indore Taxi"],
["Mumbai to Indore Cab Service","Mumbai to Indore Taxi Service"],
["Cab from Mumbai to Indore","Taxi from Mumbai to Indore"],
["Mumbai to Indore Cab Booking","Mumbai to Indore Taxi Booking Online"],
["Mumbai to Indore Cab Price","Mumbai to Indore Taxi Fare"],
["Mumbai to Indore One Way Cab","Best Cab Mumbai to Indore"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with the Mumbai to Indore highway route via NH52 and other major intercity highways. They understand traffic conditions, toll routes, and the best driving practices for a safe and smooth long-distance journey."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Indore cab bookings. We clearly explain per-kilometer fares, toll charges, and driver allowances before booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to travel overnight or during the day, Omshree Cabs offers 24/7 cab booking and customer support for Mumbai to Indore journeys."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to ensure a comfortable ride for long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel options including one-way cab services, round-trip bookings, and multi-day travel plans so travelers can customize their Mumbai to Indore journey."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles suitable for families, business travelers, and group trips."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai so your journey to Indore begins smoothly and without hassle."
  },
  {
    WhyChooseheading: "Reliable Intercity Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Indore cab services. Our punctual drivers, well-maintained vehicles, and professional service ensure a safe and reliable travel experience."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Indore by cab?", answer: "The distance from Mumbai to Indore is approximately 585 km and the journey usually takes around 10–12 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Indore cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Indore." },
  { question: "Which vehicles are available for Mumbai to Indore travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport or any location in Mumbai for Indore cab bookings." },
  { question: "Can we stop during the journey for meals or rest?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or rest breaks." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you provide overnight travel services?", answer: "Yes, many travelers prefer overnight cab journeys and our experienced drivers ensure safe night travel." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially for long-distance routes like Mumbai to Indore." },
  { question: "Do you provide corporate cab services to Indore?", answer: "Yes, Omshree Cabs provides corporate and business cab services for Mumbai to Indore travel." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Verma",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Indore trip. The driver was punctual and the car was very comfortable for the long journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Sharma",
    feedback:
      "Our family journey from Mumbai to Indore with Omshree Cabs was excellent. Clean vehicle, smooth driving, and transparent pricing made the trip stress-free.",
    rating: 5
  }
];





















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Indore Cab",
  "description": "Book Mumbai to Indore Cab with Omshree Cab for safe and comfortable outstation travel. Reliable taxi service from Mumbai to Indore with options for one-way trips. Affordable fares, easy online cab booking, and trusted cab service for your Indore journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2200"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Mumbai to Indore Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Indore Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Indore with one-way options. Affordable fares and easy online cab booking for your Indore trip." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoindorecab;